import { useImagesContext } from '../contexts/images'
import { useModuleContext } from '../contexts/module'

function useImagesInformation() {
  const { state: { artworkInformation } } = useModuleContext()
  const { images } = artworkInformation || {}
  // @ts-ignore
  const [
    {
      activeImageId,
      scrollingToImage,
      activeImageForSwipeGallery,
      swipeGalleryOpen,
      activeImageForSwipeGalleryElement
    },
    dispatch
  ] = useImagesContext()
  return {
    activeImageId,
    scrollingToImage,
    activeImageForSwipeGallery,
    swipeGalleryOpen,
    activeImageForSwipeGalleryElement,
    // @ts-ignore
    imagesForSwipeGallery: images.map(({ url, width, height }) => ({ src: url, w: width, h: height })),
    setActiveImage: id => {
      dispatch({ type: 'SET_ACTIVE_IMAGE', payload: { activeImageId: id } })
      setTimeout(() => dispatch({ type: 'SET_SCROLLING_TO_IMAGE_FALSE' }), 200)
    },
    setSwipeGalleryOpen: (imageId, imageElement) =>
      dispatch({
        type: 'SET_SWIPE_GALLERY_OPEN',
        payload: {
          activeImageForSwipeGallery: imageId,
          activeImageForSwipeGalleryElement: imageElement,
          swipeGalleryOpen: true
        }
      }),
    setSwipeGalleryClosed: () =>
      dispatch({
        type: 'SET_SWIPE_GALLERY_CLOSE',
        payload: {
          swipeGalleryOpen: false
        }
      })
  }
}

export default useImagesInformation
